import { clientId, lpRequest } from '../../../../core/api/lp-request';
import { config } from '../../../../core/config/config';

const byName = (a: any, b: any) => String(a.name).localeCompare(String(b.name));

/**
 * Every organisation whose hubs this fleet may put its drivers on, the fleet's own hubs included (with no
 * `contract_id`). Each `id` is the `promisor_id` a delivery permission stores. Hubs are sorted by name, as cb listed them.
 */
export const getAllHubOwners = async (): Promise<any[]> => {
  const owners = await lpRequest(`/fleet/${clientId()}/hub-owners`);

  return owners.map((owner: any) => ({ ...owner, hubs: [...owner.hubs].sort(byName) }));
};

/**
 * The contracted hub owners in cb's contract shape, where `promisor` is the hub owner. The fleet's own hubs are left
 * out: cb's contract list never showed them, and showing them is pending sign-off (WI-2235).
 */
export const getHubOwners = async (): Promise<any[]> => {
  const owners = await getAllHubOwners();

  return owners
    .filter((owner: any) => owner.contract_id)
    .map((owner: any) => ({
      id: owner.contract_id,
      valid: owner.valid,
      promisor: {
        id: owner.id,
        name: owner.name,
        organization: owner.organization,
        logo: owner.logo || config.images.default_logo
      },
      hubs: owner.hubs
    }));
};
